import InputLabelTooltip from '~/components/InputLabelTooltip';
import TextField from '~/components/TextField';
import { hasError } from '~/lib/graphql';
import { segmentTypes } from '~/lib/segments';
import TriggerType from '~/pages/destinations/components/TriggerType';

import sharedStyles from '../styles';
import styles from './styles';

class CustomHtml extends React.Component {
  state = {
    source: null,
    triggerType: 'page',
  };

  UNSAFE_componentWillMount() {
    if (this.props.destination) {
      this.setState({
        ...this.props.destination,
        ...this.props.destination.config,
      });
    }
  }

  handleFieldChange = (name, value) => {
    this.setState({ [name]: value }, this.handleInputChange);
  };

  handleInputChange = () => {
    const { onInputChange } = this.props;

    const { source, triggerType } = this.state;

    onInputChange({
      config: {
        source,
      },
      triggerType,
    });
  };

  render() {
    const { classes, errors, typename } = this.props;

    const { source, triggerType } = this.state;

    return (
      <>
        <h2 className={classes.subheading}>Trigger</h2>
        <span className={classes.triggerSubtext}>
          Select the event that triggers this Destination to run.{' '}
          <a
            href="https://help.clearbit.com/hc/en-us/articles/360023453694"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}>
            Learn more
          </a>
        </span>

        <TriggerType
          errors={errors}
          handleChange={this.handleFieldChange}
          triggerType={triggerType}
          triggerTypes={[
            {
              value: 'page',
              label: (
                <span className="flex">
                  On&nbsp;
                  <strong>page view</strong>{' '}
                  <InputLabelTooltip
                    style={{ top: 3 }}
                    title={`The destination is triggered every time ${
                      typename === segmentTypes.company
                        ? 'someone at the company'
                        : 'a person'
                    } hits your website.`}
                  />
                </span>
              ),
            },
          ]}
        />

        <h2 className={classes.subheading}>Configure Custom HTML</h2>

        <div className={classes.contentBox}>
          <TextField
            className={classes.field}
            error={hasError(errors, 'source')}
            fullWidth
            multiline
            rows="8"
            defaultValue={source}
            label="Custom HTML"
            onChange={(event) => {
              this.handleFieldChange('source', event.target.value);
            }}
            variant="standard"
            placeholder="Enter your HTML"
            InputProps={{
              classes: { input: classes.sourceInput },
            }}
          />
        </div>
      </>
    );
  }
}

CustomHtml.propTypes = {
  classes: PropTypes.object.isRequired,
  destination: PropTypes.object,
  errors: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  typename: PropTypes.string.isRequired,
};

export default withStyles(
  (theme) => ({
    ...sharedStyles(theme),
    ...styles(theme),
  }),
  { name: 'SegmentDestinationNewCustomHtml' },
)(CustomHtml);
